<template>
<section class="c-step-by-step-guide__step t-margin-bottom-m" :id="`step-${id}`">
    <header class="c-step-by-step-guide__step-header">
        <span class="c-step-by-step-guide__step-number">Steg {{index + 1}}</span>
        <h1 class="c-step-by-step-guide__step-heading">{{heading}}</h1>
    </header>
    <div class="c-step-by-step-guide__step-content" v-html="text"></div>
    <div class="c-step-by-step-guide__step-options">
		<template v-if="optionsType === 'buttons'" v-for="option in options">
			<button v-if="option.type === 'GuideStep'" :class="`c-button c-button--secondary ${(selectedOption === option.id) ? 'selected' : ''}`" @click.prevent="fetchStep(option.id, option.text)">{{option.text}}</button>
			<a v-if="option.type === 'Link' && option.url" class="c-button c-button--secondary" :href="option.url">{{option.text}}</a>
		</template>
		<fieldset v-if="optionsType === 'radio'" class="c-radio-group">
			<template v-for="option in options">
				<div v-if="option.type === 'GuideStep'" class="c-radio">
					<input type="radio" name="radio" class="c-radio__input" :id="option.id" @change="fetchStep(option.id, option.text)" :checked="(selectedOption === option.id) ? 'selected' : false">
					<label :for="option.id" class="c-radio__label">{{option.text}}</label>
				</div>
				<p v-if="option.type === 'Link' && option.url">
					<a :href="option.url">{{option.text}}</a>
				</p>
			</template>
		</fieldset>
    </div>
</section>
</template>

<script>
export default {
    name: 'GuideStep',
    props: {
        id: {
            type: String,
            default: ''
        },
        heading: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: ''
        },
		optionsType: {
			type: String,
			default: 'buttons'
		},
        options: {
            type: Array,
            default: () => []
        },
		index: {
			type: Number,
			default: 0
		},
		selectedOption: {
			type: String,
			default: ''
		}
    },
    methods: {
		fetchStep(stepId, stepText) {
			this.$emit('fetchStep', {appendAfter: this.id, stepId: stepId, stepText: 'Steg ' + (this.index + 1) + ': ' + stepText});
		}
    },
    created() {
    }
}
</script>
